import React from "react";
import { Link } from "react-router-dom";
import stealthMark from "../../Assets/Images/logo.svg";
import "./index.scss";

// The spy mark in a ringed circle — the same badge as the favicon and the
// "Built for hiring teams" diagram. The redesign had drawn a generic shield
// here instead, so the header didn't match the brand.
const Logo = ({ className = "" }) => (
  <Link to="/" className={`brand-logo ${className}`}>
    <span className="brand-logo-mark" aria-hidden="true">
      <img src={stealthMark} alt="" />
    </span>
    <span className="brand-logo-text">Stealth Jobs</span>
  </Link>
);

export default Logo;
